// @flow
import React from "react"
import { connect } from "react-redux"
import NavBar from "@kiwicom/nitro/lib/components/NavBar"

import { cuckooEvents } from "common/consts/enums"
import cuckoo from "../../services/cuckoo/cuckoo"
import urlPrefixSelector from "../../services/url/prefixSelector"
import { getLastUrl } from "../../services/history/historyDuck"
import MainView from "../MainView/MainView"
import changeLanguage from "../../utils/changeLanguage"
import FullPageMessage from "../FullPageMessage/FullPageMessage"
import translateSelector from "../../services/intl/translateSelector"
import type { TranslateFunc } from "../../../../app/scripts/tools/translate"

// NavBar imports
import * as nitroSideEffects from "../../utils/nitroSideEffects"
import HeaderLinks from "../HeaderLinks/HeaderLinks"
import NavbarStarred from "../../../../app/scripts/modules/Navbar/components/NavbarStarred/NavbarStarred"
import DebugModal from "../../../../app/scripts/modules/Debug/DebugModal"
import SubscriptionModal from "../../../../app/scripts/modules/Auth/SubscriptionModal"
import { openHelp } from "../../modules/SmartFAQ/services/SmartFAQDuck"
import mmbSelectTrip from "../../services/auth/mmbSelectTrip"
import { getLanguage } from "../../services/options/reducer"
import checkDebugEnabled from "../../utils/checkDebugEnabled"

type Props = {
  urlPrefix: string,
  lastUrl: string,
  language: string,
  routes: *,
  params: *,
  translate: TranslateFunc,
  openFAQ: () => void,
}

class PageNotFound extends React.Component<Props> {
  componentDidMount() {
    const { lastUrl } = this.props
    cuckoo.track(cuckooEvents.PAGE_NOT_FOUND, {
      status: 404,
      referrer: lastUrl,
    })
  }

  render() {
    const { urlPrefix, routes, params, translate, language, openFAQ } = this.props

    return (
      <MainView
        routes={routes}
        params={params}
        onChangeLanguage={changeLanguage}
        navbar={
          <NavBar
            headerLinks={<HeaderLinks searchForm={null} />}
            subscription={<SubscriptionModal />}
            debug={Boolean(checkDebugEnabled()) && <DebugModal />}
            starred={<NavbarStarred />}
            onOpenFaq={openFAQ}
            onSaveLanguage={changeLanguage}
            onSelectTrip={id => mmbSelectTrip(language, id)}
            onSetModal={nitroSideEffects.modals}
            onLogoClick={nitroSideEffects.logoClick}
            portal="modals"
          />
        }
      >
        <FullPageMessage
          imgSrc="/images/illust/404@_1x.png"
          imgSrcSet="/images/illust/404@_2x.png 2x"
          header={translate("common.404.something_went_wrong")}
          text={translate("common.404.return_on_homepage")}
          href={`${urlPrefix}/`}
        />
      </MainView>
    )
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    urlPrefix: urlPrefixSelector(state),
    lastUrl: getLastUrl(state),
    translate: translateSelector(state),
    // navbar
    helpCenter: state.helpCenter,
    language: getLanguage(state),
  }),
  dispatch => ({
    // navbar
    openFAQ: () => {
      dispatch(openHelp(null))
    },
  }),
)(PageNotFound)
